// extracted by mini-css-extract-plugin
export var active = "_dz-7";
export var container = "_dz-0";
export var evenWidth = "_dz-4";
export var large = "_dz-5";
export var outlet = "_dz-8";
export var slide = "_dz-2";
export var small = "_dz-6";
export var tab = "_dz-3";
export var tabs = "_dz-1";